<template>
  <div class="mt-8">
    <Banner :key="uuid" />

    <ModalRememberClose />
    
    <ModalGlobal
      id="modalUnlockPark"
      v-if="modalUnlockPark"
      @close-modal="modalUnlockPark = false"
    >
      <template #dialogHeadImg>
        <img
          class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
          src="https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png"
          alt="logo photo"
        />
      </template>

      <!-- <template #dialogHeading> 3/3 Albumes seleccionados </template> -->

      <template #dialogDescription>
        <p class="font-bold mb-3 text-center">
          {{ unlockPark.selectedParks }}/{{ unlockPark.availableParks }}
          {{ $t("gallery.album_select") }}
        </p>
        <p class="text-sm mb-3 text-center">
          {{ $t("gallery.album_confirm") }}
        </p>
        <p class="font-bold mb-4 text-center">
          {{ $t("gallery.park_unlock") }}
        </p>
      </template>

      <a
        @click.prevent="addVisitPark()"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto"
      >
        {{ $t("gallery.album_unlock") }}
      </a>

      <button
        @click="modalUnlockPark = false"
        type="button"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-white cursor-pointer font-semibold mx-auto"
      >
        {{ $t("gallery.continue") }}
      </button>
    </ModalGlobal>

    <ModalGlobal
      id="modalDeleteTags"
      v-if="modalDeleteTags"
      @close-modal="modalDeleteTags = false"
    >
      <template #dialogHeadImg>
        <img
          class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
          src="https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png"
          alt="logo photo"
        />
      </template>

      <!-- <template #dialogHeading> 3/3 Albumes seleccionados </template> -->

      <template #dialogDescription>
        <p class="font-bold mb-3 text-center">
          {{ $tc("Forms.tags", deleteTags.tags.length) }}({{
            deleteTags.tags.length
          }})
        </p>

        <div class="isoCurrencies flex flex-wrap -mb-1">
          <div
            class="btnDeleteTags flex justify-center rounded py-3 px-4 mb-1 border-yellow-photo border bg-white font-semibold"
            v-for="(item, idx) in deleteTags.tags"
            :key="idx"
          >
            {{ item }}
            <span
              @click.prevent="tagsToRemove(idx)"
              class="deleteTags material-icons cursor-pointer"
              v-if="deleteTags.tags.length > 1"
            >
              highlight_off
            </span>
          </div>
        </div>
      </template>

      <!-- <a
        @click.prevent="addVisitPark()"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-4 bg-yellow-photo cursor-pointer font-semibold mx-auto"
      >
        {{ $t("gallery.album_unlock") }}
      </a> -->

      <button
        @click="modalDeleteTags = false"
        type="button"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-1 mt-6 border-yellow-photo border bg-yellow-photo shadow-lg cursor-pointer font-semibold mx-auto"
      >
        {{ $t("gallery.continue") }}
      </button>
    </ModalGlobal>

    <!-- <a @click.prevent="$store.dispatch('cleanAfterShopping')">Clear ShoppingCart</a> -->

    <section
      :key="$store.getters.updateAlbumComponent"
      class="flex flex-col-reverse md:flex-row container mx-auto menu"
    >
      <div class="flex flex-col w-full px-4 pt-8">
        <div class="w-full md:w-3/4 flex justify-right items-end pb-4">
          <button
            class="w-3/4 py-2 px-4 bg-white border-black"
            :class="[
              $store.state.typeCodeTab == 0
                ? 'active border-x border-t rounded-t-lg'
                : 'border-b',
              !$store.state.tabDownloadCode && 'cursor-no-drop disabled hidden',
            ]"
            @click.prevent="
              $store.state.tabDownloadCode &&
                $store.dispatch('setTypeCodeTab', 0)
            "
            type="button"
          >
            <span class="albumes material-icons"> qr_code_scanner </span>
            <span class="font-semibold">{{
              $tc("Forms.download_code", 2)
            }}</span>
          </button>
          <button
            class="w-3/4 py-2 px-4 bg-white border-black"
            :class="[
              $store.state.typeCodeTab == 1
                ? 'active border-x border-t rounded-t-lg'
                : 'border-b',
              !$store.state.tabTags && 'cursor-no-drop disabled hidden',
            ]"
            @click.prevent="
              $store.state.tabTags && $store.dispatch('setTypeCodeTab', 1)
            "
            type="button"
          >
            <span class="albumes material-icons"> bookmark </span>
            <span class="font-semibold">{{ $tc("Forms.tags", 2) }}</span>
          </button>
          <button
            class="w-3/4 py-2 px-4 bg-white border-black"
            :class="[
              $store.state.typeCodeTab == 2
                ? 'active border-x border-t rounded-t-lg'
                : 'border-b',
              !$store.state.tabReservations && 'cursor-no-drop disabled hidden',
            ]"
            @click.prevent="
              $store.state.tabReservations &&
                $store.dispatch('setTypeCodeTab', 2)
            "
            type="button"
          >
            <span class="albumes material-icons"> apartment </span>
            <span class="font-semibold">{{
              $tc("Forms.reservations", 2)
            }}</span>
          </button>

          <button
            class="w-3/4 py-2 px-4 bg-white border-black"
            :class="[
              $store.state.typeCodeTab == 5
                ? 'active border-x border-t rounded-t-lg'
                : 'border-b',
              !$store.state.tabFreeGallery && 'cursor-no-drop disabled hidden',
            ]"
            @click.prevent="
              $store.state.tabFreeGallery &&
                $store.dispatch('setTypeCodeTab', 5)
            "
            type="button"
          >
            <span class="albumes material-icons"> redeem </span>
            <span class="font-semibold">
              {{ $t("gallery.free_albums") }}
            </span>
          </button>
        </div>

        <!-- <button
            class="
              shadownBottom
              md:flex
              w-1/3
              flex-row
              items-center
              justify-center
              relative
              cursor-pointer
              bg-yellow-photo
              rounded-full
              px-4
              py-4
            "
            @click.prevent="
              $store.dispatch('clearShoppingCart')
            "
            type="button"
          >
            Eliminar Albumes
          </button> -->

        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 0">
          <template v-for="(item, index) in $store.state.albumes">
            <!-- Codigos de descarga -->
            <section
              class="flex flex-col md:flex-row container mx-auto flex-wrap"
              :key="index"
              v-if="item.Type === 0"
            >
              <div class="relative flex w-full mb-10 px-8 justify-center">
                <hr class="flex w-full mt-10 border-black border-b" />
                <div
                  class="absolute flex flex-auto bg-white top-8 right-8 pl-8"
                >
                  <span class="font-bold mr-1">{{ $t("gallery.code") }} </span>
                  <span class="mr-1">{{ item.code }}</span>
                  |
                  <span class="ml-1">
                    <button
                      @click.prevent="updateAlbum(item.code)"
                      type="button"
                      class="updateAlbum shadownBottom flex w-full justify-center items-center p-2 pl-4 pr-4 bg-yellow-photo rounded text-sm cursor-pointer"
                    >
                      <span class="material-icons"> autorenew </span>
                    </button>
                  </span>
                  <!-- |
                                    <span class="ml-1">{{
                                        $tc(
                                            "messages.albumes",
                                            item.AvailableParks
                                        )
                                    }}</span> -->
                </div>
              </div>

              <div
                class="w-full md:w-1/3 px-8 mb-8"
                v-for="(park, index2) in item.park"
                :key="index2"
              >
                <router-link
                  class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                  :to="{
                    name: 'gallery',
                    query: {
                      uuid: item.uuid,
                      parkID: park.Park.Id,
                      type: item.Type,
                      page: 1,
                      albumType: park.AlbumType,
                      albumId: park.AlbumKey.Id,
                    },
                  }"
                >
                  <div class="coverAlbumes relative pointer-events-none">
                    <img
                      :src="park.Thumb"
                      @error="replaceImgByDefault($event, park.Park.Id)"
                      alt="albumes"
                      class="w-full opacity-70"
                    />

                    <img
                      :src="park.Thumb"
                      @error="replaceImgByDefault($event, park.Park.Id)"
                      alt="albumes"
                      class="w-full absolute top-2 left-2"
                    />
                  </div>

                  <div class="flex py-3 items-center pointer-events-none">
                    <div class="w-1/2 flex items-center">
                      <img
                        :src="
                          'https://photo-public.s3.amazonaws.com/suf/logos/albumes/hotel-' +
                          park.Park.Id +
                          '.png'
                        "
                        :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-if="park.IsBook"
                      />
                      <img
                        :src="
                          'https://photo-public.s3.amazonaws.com/suf/logos/albumes/park-' +
                          park.Park.Id +
                          '.png'
                        "
                        :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-else
                      />
                    </div>

                    <div class="w-1/2 flex flex-col items-end">
                      <div>
                        <template v-if="park.AlbumType == 1">
                          <span class="albumes material-icons">
                            smart_display
                          </span>
                          <span>
                            {{ $tc("messages.videos", park.TotalMedia) }}
                          </span>
                        </template>

                        <template v-else>
                          <span class="albumes material-icons">
                            crop_original
                          </span>
                          <span>
                            {{ $tc("messages.photos", park.TotalMedia) }}
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                </router-link>

                <template v-if="!park.Unlocked && item.order == 0">
                  <!-- {{ isParkForSale(index) }} -->
                  <button
                    type="button"
                    class="shadownBottom flex w-full justify-center items-center p-2 bg-blue-700 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="unlockParks(index, park.Park.Id)"
                    v-if="!isParkForSale(index)"
                  >
                    {{ $t("gallery.unlock") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      lock_open
                    </span>
                  </button>                
                  <template v-if="isParkForSale(index)">
                    <button
                      type="button"
                      class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-no-drop"
                      v-if="
                        item.FreeHotels &&
                        park.Park.IsHotel &&
                        park.AlbumType === 0
                      "
                    >
                      {{ $t("gallery.free") }}
                    </button>
                    <button
                      type="button"
                      class="shadownBottom flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                      @click="
                        $store.dispatch('removeShoppingCartByDownloadCode', {
                          park,
                          idx: index,
                        })
                      "
                      v-else-if="park.IsAdded"
                    >
                      <!-- $store.dispatch('removeAlbumFromShoppingCart',{ album: item, albumIndex: index }) -->
                      {{ $t("gallery.cart_quit") }} &nbsp;&nbsp;
                      <span class="albumes addcart material-icons">
                        delete
                      </span>
                    </button>
                    <button
                      type="button"
                      class="shadownBottom flex w-full justify-center items-center p-2 bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer" 
                      @click.prevent="
                        $store.dispatch('addCartByDownloadCode', {
                          idx: index,
                          park,
                        })
                      "
                      v-else
                    >
                      {{ $t("gallery.cart_add") }} &nbsp;&nbsp;
                      <span class="albumes addcart material-icons">
                        local_grocery_store
                      </span>
                    </button>
                  </template>
                </template>

                <button
                  type="button"
                  class="hidden flex w-full justify-center p-2 border border-newxcaret-blue bg-white text-newxcaret-blue rounded-full text-sm cursor-pointer"
                >
                  {{ $t("gallery.album_download") }}
                </button>
              </div>
            </section>
          </template>
        </div>
        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 1">
          <template v-for="(item, index) in $store.state.albumes">
            <!-- Brazalete -->
            <section
              class="flex flex-col md:flex-row container mx-auto flex-wrap"
              v-if="item.Type === 1"
              :key="index"
            >
              <div class="relative flex w-full mb-10 px-8 justify-center">
                <hr class="flex w-full mt-10 border-black border-b" />
                <div
                  class="absolute flex flex-auto bg-white top-8 right-8 pl-8"
                >
                  <span class="font-bold mr-1"
                    >{{ $tc("Forms.tags", item.Tags.length) }}
                  </span>
                  <!-- <span class="mr-1">{{ item.code }}</span> -->
                  |
                  <span class="ml-1">
                    <button
                      @click.prevent="deleteTagsAlbum(item)"
                      type="button"
                      class="updateAlbum shadownBottom flex w-full justify-center items-center p-2 pl-4 pr-4 bg-yellow-photo rounded text-sm cursor-pointer"
                    >
                      <span class="material-icons"> visibility </span>
                    </button>
                  </span>
                  <!-- |
                                    <span class="ml-1">{{
                                        $tc(
                                            "messages.albumes",
                                            item.AvailableParks
                                        )
                                    }}</span> -->
                </div>
              </div>

              <div
                class="w-full md:w-1/3 px-8 mb-8"
                v-for="(park, index2) in item.park"
                :key="index2"
              >
                <router-link
                  class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                  :to="{
                    name: 'gallery',
                    query: {
                      uuid: item.uuid,
                      parkID: park.Park.Id,
                      type: item.Type,
                      page: 1,
                      albumType: park.AlbumType,
                      albumId: park.AlbumKey.Id,
                    },
                  }"
                >
                  <div class="coverAlbumes relative pointer-events-none">
                    <img
                      :src="park.Thumb"
                      :alt="park.Park.Name"
                      @error="replaceImgByDefault($event, park.Park.Id)"
                      class="w-full opacity-70"
                    />

                    <img
                      :src="park.Thumb"
                      :alt="park.Park.Name"
                      @error="replaceImgByDefault($event, park.Park.Id)"
                      class="w-full absolute top-2 left-2"
                    />
                  </div>

                  <div class="flex py-3 items-center pointer-events-none">
                    <div class="w-1/2 flex items-center">
                      <img
                        :src="
                          'https://photo-public.s3.amazonaws.com/suf/logos/albumes/hotel-' +
                          item.ParkID +
                          '.png'
                        "
                        :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-if="park.IsBook"
                      />
                      <img
                        :src="
                          'https://photo-public.s3.amazonaws.com/suf/logos/albumes/park-' +
                          item.ParkID +
                          '.png'
                        "
                        :alt="park.Park.Name"
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-else
                      />
                    </div>

                    <div class="w-1/2 flex flex-col items-end">
                      <div>
                        <template v-if="park.AlbumType == 1">
                          <span class="albumes material-icons">
                            smart_display
                          </span>
                          <span>
                            {{ $tc("messages.videos", park.TotalMedia) }}
                          </span>
                        </template>

                        <template v-else>
                          <span class="albumes material-icons">
                            crop_original
                          </span>
                          <span>
                            {{ $tc("messages.photos", park.TotalMedia) }}
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>
                </router-link>

                <template v-if="park.CustomService != null">
                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click="
                      $store.dispatch('removeParkServiceIdFromShoppingCart', {
                        park,
                        tag: item.code,
                      })
                    "
                    v-if="park.IsAdded"
                  >
                    {{ $t("gallery.cart_quit") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons"> delete </span>
                  </button>

                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="
                      $store.dispatch('addCartByServiceId', {
                        park,
                        tag: item.code,
                      })
                    "
                    v-else-if="park.AlbumType == 0"
                  >
                    {{ $t("gallery.cart_add") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      local_grocery_store
                    </span>
                  </button>
                </template>
                <template v-else>
                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                    @click="
                      $store.dispatch('removeAlbumFromShoppingCart', {
                        album: park,
                        albumIndex: index,
                      })
                    "
                    v-if="park.IsAdded"
                  >
                    {{ $t("gallery.cart_quit") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons"> delete </span>
                  </button>

                  <button
                    type="button"
                    class="flex w-full justify-center items-center p-2 shadownBottom bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer"
                    @click.prevent="$store.dispatch('addCartByTag', park)"
                    v-else-if="park.AlbumType == 0"
                  >
                    {{ $t("gallery.cart_add") }} &nbsp;&nbsp;
                    <span class="albumes addcart material-icons">
                      local_grocery_store
                    </span>
                  </button>
                </template>
              </div>
            </section>
          </template>
        </div>
        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 2">
          <template v-for="(item, index) in $store.state.albumes">
            <!-- Room -->
            <section
              class="albumes flex flex-col md:flex-row container mx-auto flex-wrap"
              v-if="item.Type == 2"
              :key="index"
            >
              <div class="relative flex w-full mb-10 px-8 justify-center">
                <hr class="flex w-full mt-10 border-black border-b" />
                <div
                  class="absolute flex flex-auto bg-white top-8 right-8 pl-8"
                >
                  <span class="font-bold mr-1"
                    >{{ $t("gallery.reserv") }}
                  </span>
                  <span class="mr-1">#{{ item.code }}</span>
                  <!-- |
                                    <span class="ml-1">{{
                                        $tc("messages.albumes", item.albumes)
                                    }}</span> -->
                </div>
              </div>

              <div
                class="album w-full md:w-1/3 px-8 mb-8"
                v-for="(park, idx2) in item.park"
                :key="idx2"
              >
                <router-link
                  class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                  :to="{
                    name: 'gallery',
                    query: {
                      uuid: item.uuid,
                      parkID: park.Park.Id,
                      type: item.Type,
                      page: 1,
                      albumType: park.AlbumType,
                      albumId: park.AlbumKey.Id,
                    },
                  }"
                >
                  <div class="coverAlbumes relative pointer-events-none">
                    <img
                      @error="replaceImgByDefault($event, park.Park.Id)"
                      :src="
                        'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' +
                        park.Park.Id +
                        '.jpg'
                      "
                      alt="albumes"
                      class="w-full opacity-70"
                    />

                    <img
                      @error="replaceImgByDefault($event, park.Park.Id)"
                      :src="
                        'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' +
                        park.Park.Id +
                        '.jpg'
                      "
                      alt="albumes"
                      class="w-full absolute top-2 left-2"
                    />
                  </div>

                  <div class="flex py-3 items-center pointer-events-none">
                    <div class="w-1/2 flex items-center">
                      <img
                        :src="
                          'https://photo-public.s3.amazonaws.com/suf/logos/albumes/hotel-' +
                          park.Park.Id +
                          '.png'
                        "
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-if="park.IsBook"
                      />
                      <img
                        :src="
                          'https://photo-public.s3.amazonaws.com/suf/logos/albumes/park-' +
                          park.Park.Id +
                          '.png'
                        "
                        class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                        v-else
                      />
                    </div>

                    <div class="w-1/2 flex flex-col items-end">
                      <div class="w-3/4 flex flex-col items-end">
                        <div>
                          <template v-if="park.AlbumType == 1">
                            <span class="albumes material-icons">
                              smart_display
                            </span>
                            <span>
                              {{ $tc("messages.videos", park.TotalMedia) }}
                            </span>
                          </template>

                          <template v-else>
                            <span class="albumes material-icons">
                              crop_original
                            </span>
                            <span>
                              {{ $tc("messages.photos", park.TotalMedia) }}
                            </span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>

                <button
                  type="button"
                  class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-no-drop"
                  v-if="
                    item.FreeHotels && park.Park.IsHotel && park.AlbumType === 0
                  "
                >
                  {{ $t("gallery.free") }}
                </button>
                <button
                  type="button"
                  class="flex w-full justify-center items-center p-2 bg-red-500 text-white rounded-full text-sm font-bold cursor-pointer"
                  @click="
                    $store.dispatch('removeShoppingCartByRoom', {
                      park,
                      idx: index,
                    })
                  "
                  v-else-if="park.IsAdded"
                >
                  {{ $t("gallery.cart_quit") }} &nbsp;&nbsp;
                  <span class="albumes addcart material-icons"> delete </span>
                </button>
                <button
                  type="button"
                  class="flex w-full justify-center items-center p-2 bg-green-xcaret text-white rounded-full text-sm font-bold cursor-pointer"
                  @click.prevent="
                    $store.dispatch('addCartByRoom', {
                      park,
                      idx: index,
                    })
                  "
                  v-else-if="park.AlbumType == 0"
                >
                  {{ $t("gallery.cart_add") }} &nbsp;&nbsp;
                  <span class="albumes addcart material-icons">
                    local_grocery_store
                  </span>
                </button>
              </div>
            </section>
          </template>
        </div>
        <div class="active tabs-content" v-if="$store.state.typeCodeTab == 5">
          <!-- Free Gallery -->
          <section
            class="albumes flex flex-col md:flex-row container mx-auto flex-wrap"
          >
            <div class="relative flex w-full mb-10 px-8 justify-center">
              <hr class="flex w-full mt-10 border-black border-b" />
              <div class="absolute flex flex-auto bg-white top-8 right-8 pl-8">
                <span class="font-bold mr-1">{{ $t("gallery.free_albums") }}</span>
                <!-- <span class="mr-1">#{{ item.code }}</span> -->
              </div>
            </div>

            <div
              class="album w-full md:w-1/3 px-8 mb-8"
              v-for="(park, idx) in freeAlbumsFiltered"
              :key="idx"
            >
              <router-link
                class="flex flex-col cursor-pointer hover:scale-105 duration-300"
                :to="{
                  name: 'gallery',
                  query: {
                    parkID: park.parkId,
                    type: 5,
                    page: 1,
                    albumType: 0,
                    albumId: park.parkId,
                    freeGallery: true
                  },
                }"
              >
                <div class="coverAlbumes relative pointer-events-none">
                  <img
                    @error="replaceImgByDefault($event, park.parkId)"
                    :src="
                      'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' +
                      park.parkId +
                      '.jpg'
                    "
                    alt="albumes"
                    class="w-full opacity-70"
                  />

                  <img
                    @error="replaceImgByDefault($event, park.parkId)"
                    :src="
                      'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' +
                      park.parkId +
                      '.jpg'
                    "
                    alt="albumes"
                    class="w-full absolute top-2 left-2"
                  />
                </div>

                <div class="flex py-3 items-center pointer-events-none">
                  <div class="w-1/2 flex items-center">
                    <img
                      :src="
                        'https://photo-public.s3.amazonaws.com/suf/logos/albumes/hotel-' +
                        park.parkId +
                        '.png'
                      "
                      class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                      v-if="park.IsBook"
                    />
                    <img
                      :src="
                        'https://photo-public.s3.amazonaws.com/suf/logos/albumes/park-' +
                        park.parkId +
                        '.png'
                      "
                      class="logosParks w-full h-auto max-w-28 max-h-12 inline-block object-contain"
                      v-else
                    />
                  </div>

                  <div class="w-1/2 flex flex-col items-end">
                    <div>
                      <span class="albumes material-icons">
                        crop_original
                      </span>
                      <span>
                        {{ $tc("messages.photos", park.TotalMedia) }}
                      </span>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </section>
        </div>
        <div class="active tabs-content" v-if="!$store.state.albumes.length">
          <img
            class="no-data"
            src="https://photo-public.s3.amazonaws.com/suf/no-data.png"
            alt=""
          />
        </div>
      </div>
    </section>

    <!-- <button v-on:click="show = !show">
    Mostrar/Ocultar
  </button>
  <transition name="fade">
    <p v-if="show">hola</p>
  </transition> -->

    <TranferProgressWidget />
  </div>
</template>

<script>
import AlbumesMix from "../components/mixins/Albumes";

import Banner from "../components/store/shoppingCartCounterComponent.vue";
import Footer from "../components/Footer.vue";
import ModalRememberClose from "../components/Modals/CloseSessionModal.vue";
import ShoppingCartCounter from "../components/store/shoppingCartCounterComponent.vue";
import Gallery from "./Gallery.vue";
import TranferProgressWidget from "../components/photo/DownloadedMultimediaComponent.vue";

export default {
  mixins: [AlbumesMix],
  components: {
    Banner,
    Footer,
    ShoppingCartCounter,
    Gallery,
    TranferProgressWidget,
    ModalRememberClose
  },
  data: () => ({
    components: {},
    uuid: 100,
    show: true,
    freeAlbums: [],
    freeAlbumsFiltered: []
  }),
  computed: {
    shoppingCartAmount: {
      // getter
      get() {
        return Object.value(this.$store.state.albumes).lenght;
      },
      // setter
      set(newValue) {
        // Note: we are using destructuring assignment syntax here.
        // [this.firstName, this.lastName] = newValue.split(' ')
      },
    },
  },
  methods: {
    replaceImgByDefault(e, parkID) {
      e.target.src = `https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-${parkID}.jpg`;
    },
    forceRerender() {
      this.uuid += 1;
    },
    imageToBlob(url) {
      return new Promise(function (resolve, reject) {
        try {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url);
          xhr.responseType = "blob";
          xhr.onerror = function () {
            reject("Network error.");
          };
          xhr.onload = function () {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject("Loading error:" + xhr.statusText);
            }
          };
          xhr.send();
        } catch (err) {
          reject(err.message);
        }
      });
    },
    blobToBase64() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    packageFilter(data, service) {
      return data.filter(park => {
        if (park.isEvent) {
            return service.some(pkg => park.AvailablePackage.includes(pkg));
        }
        return true;
    });
    },
    async getFreeAlbumes() {
      const s3PublicBucket = document.querySelector('meta[name="s3PublicBucket"]').getAttribute("content");
      const response = await axios(`${s3PublicBucket}/suf/free-albumes/data/paths.json`);
      return response.data;
    },
    async getFilteredPackage(){
      let filteredFreeAlbums = this.packageFilter(this.freeAlbums, this.$store.getters.getPackages);
      this.freeAlbumsFiltered = filteredFreeAlbums.map((item) => {
      return {
        parkId: item.ParkId,
        TotalMedia: item.TotalPhotos,
        parkName: item.parkName
      }
    });
    },
  },
  watch: {
    '$store.state.albumes' (){
      this.getFilteredPackage() 
    }
  },
  async mounted() {
  },
  async created() {
    await this.$store.dispatch('cleanEventDetails');
    await this.$store.dispatch('removeEventFromShoppingCart');
    this.getFreeAlbumes().then(freeAlbums => {
      this.freeAlbums = freeAlbums;
      return this.getFilteredPackage();
    })
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
